module.exports = __webpack_public_path__ + "img/Group 308@2x.cd73a9de.png";